import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card-box',
  templateUrl: './card-box.component.html',
  styleUrls: ['./card-box.component.scss']
})

export class CardBoxComponent implements OnInit {
  @Input() data = {
    image: 'https://images.placeholders.dev/?width=348&height=200&text=Not%20Found&font=roboto&bgColor=cccccc',
  };

  private fallbackSet = false;

  onImgError(event: Event) {
    if (!this.fallbackSet) {
      const img = event.target as HTMLImageElement;
      img.src = 'assets/images/lots/default-lot.png';
      this.fallbackSet = true;
    }
  }

  constructor() {}

  ngOnInit(): void {}
}
